export default __webpack_public_path__ + "static/media/sub-category-hair-beauty-aesthetics.b739b30e.jpg";